import React, { useEffect, useState } from "react";
import Aos from "aos";
import ProductCardLoader from "../common/loaders/product-card-loader";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import axios from "axios";
import { getPackageUrl } from "../package/packageSeo";
import { API_BASE_URL, CLIENT_BASE_PATH } from "../../environment";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ReactDatePicker from "react-datepicker";
import PhoneNumberField from "../home/phoneNumberField";
import { setMeta } from "../../core/data/utils/meta";
import { buildTaxiServiceSchema } from "../../core/data/utils/schema";
import { ar_routes } from "../router/ar_routes";

const ArJaddahAirportTaxiService = () => {
  const [packagesList, setPackagesList] = useState<any[]>([]);
  const [confirmBookingData, setConfirmBookingData] = useState<any>([]);
  const [isloading, setIsLoading] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [bookingConfirmToggle, setBookingConfirmToggle] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [locationsList, setLocationsList] = useState<any>([]);
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  useEffect(() => {
    const canonicalUrl = `${CLIENT_BASE_PATH}/ar/jaddah-airport-taxi-service`;
    const title = "خدمة تاكسي مطار جدة | نقل العمرة إلى مكة والمدينة";
    const description = "خدمة تاكسي موثوقة من مطار جدة لمعتمري العمرة. استمتع بنقل على مدار الساعة إلى مكة والمدينة والفنادق مع سائقين ذوي خبرة وأسعار ثابتة.";
    setMeta(
      title,
      description,
      canonicalUrl,
      `${CLIENT_BASE_PATH}/assets/img/gallery/hero-payment.png`,
      {
        keywords: "تاكسي مطار جدة, نقل من جدة إلى مكة, تاكسي جدة إلى المدينة, نقل مطار للعمرة",
        locale: "ar",
        alternateUrl: `${CLIENT_BASE_PATH}/jaddah-airport-taxi-service`,
        structuredData: buildTaxiServiceSchema({
          pageUrl: canonicalUrl,
          name: title,
          description,
          image: `${CLIENT_BASE_PATH}/assets/img/gallery/hero-payment.png`,
          serviceType: ["Jeddah Airport taxi service", "Umrah airport transfer", "Airport transfer to Makkah", "Airport transfer to Madinah"],
          areaServed: [{ "@type": "City", name: "Jeddah" }, { "@type": "City", name: "Makkah" }, { "@type": "City", name: "Madinah" }],
        }),
      }
    );
  }, []);

  useEffect(() => {
    const fetchLocationsList = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/locations/list`);
        setLocationsList(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching locations:", error);
        setIsLoading(false);
      }
    };

    fetchLocationsList();
  }, []);

  useEffect(() => {
    const fetchPackages = async () => {
      const locationId= locationsList.find((loc:any) => loc.name === "Jeddah Airport")?.id;
      if (locationId) {
        try {
          const response = await axios.post(`${API_BASE_URL}/packages/list`, {
            pickup_location: locationId,
          });
          setPackagesList(response.data);
        } catch (error) {
          console.error("Error fetching packages:", error);
        }
      }
    };

    if (locationsList.length > 0) {
      fetchPackages();
    }
  }, [locationsList]);
  const schemaWithPersonalDetails = Yup.object().shape({
    name: Yup.string().required("الاسم مطلوب"),
    email: Yup.string()
      .email("بريد إلكتروني غير صالح")
      .required("البريد الإلكتروني مطلوب"),
    pickup_date_time1: Yup.string().required("اختر تاريخ ووقت الاستلام"),
    phone_no: Yup.string().required("رقم الهاتف مطلوب"),
  });

  const {
    handleSubmit: handlePackageSubmit,
    control: handleController,
    formState: { errors: personalDetailsErrors },
    reset,
  } = useForm({
    resolver: yupResolver(schemaWithPersonalDetails),
  });

  const onSubmitPersonalDetails = async (bookingFormData: any) => {
    setIsLoading(true);
    try {
      const payload = {
        package_id: confirmBookingData.id,
        pickup_date_time: bookingFormData.pickup_date_time1,
        phone_no: bookingFormData.phone_no,
        name: bookingFormData.name,
        email: bookingFormData.email,
        user_id: "",
        baby_seat: confirmBookingData.vehicle_detail.baby_seat,
      };
      const response = await axios.post(
        `${API_BASE_URL}/packages/booking`,
        payload
      );
      if (response.status == 201 || response.status == 200) {
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setErrorMessage("");
        setSuccessMessage(response.data.message);
        setIsLoading(false);
      } else {
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setErrorMessage(response.data.message);
        setSuccessMessage("");
        setIsLoading(false);
      }
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMessage(error.response.data.message);
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setSuccessMessage("");
        setIsLoading(false);
      } else {
        setBookingConfirmToggle(false);
        setIsBookingModalOpen(true);
        setErrorMessage("حدث خطأ. يرجى المحاولة مرة أخرى لاحقاً.");
        setIsLoading(false);
      }
    } finally {
      setConfirmBookingData([]);
      reset();
    }
  };

  const handleBookingPackages = (bookingData: any) => {
    setConfirmBookingData(bookingData);
    setBookingConfirmToggle(true);
  };
  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
  };
  const closePackagesBooking = () => {
    setBookingConfirmToggle(false);
    setConfirmBookingData([]);
  };


  return (
    <>
    <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">خدمة تاكسي مطار جدة</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={ar_routes.home}>الرئيسية</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                  خدمة تاكسي مطار جدة
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

        {isBookingModalOpen && (
        <div
          className={` ${isloading ? "pointer-event-none" : ""} modal new-modal fade d-block show`}
          id="delete_modal"
          data-keyboard="false"
          data-backdrop="static"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="delete-action">
                  <div className="delete-header">
                    <h4>حالة الحجز</h4>
                  </div>
                  {isloading && (
                    <p className="py-4">
                      يرجى الانتظار، حجزك قيد التنفيذ ...
                    </p>
                  )}
                  {successMessage && (
                    <p className="py-4 text-success">{successMessage}</p>
                  )}
                  {errorMessage && (
                    <p className="py-4 text-danger">{errorMessage}</p>
                  )}

                  <div className="modal-btn">
                    <div className="row">
                      <div className="col-6 m-auto">
                        <button
                          onClick={closeBookingModal}
                          className="btn btn-primary w-100"
                        >
                          إغلاق
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isBookingModalOpen && <div className="modal-backdrop fade show"></div>}
      {bookingConfirmToggle && (
        <div
          className={` ${isloading ? "pointer-event-none" : ""} modal new-modal multi-step fade d-block show`}
          id="complete_booking"
          data-keyboard="false"
          data-backdrop="static"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <form onSubmit={handlePackageSubmit(onSubmitPersonalDetails)}>
              <div className="modal-content">
                <div className="modal-header" onClick={closePackagesBooking}>
                  <button
                    type="button"
                    className="close-btn"
                    data-bs-dismiss="modal"
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="booking-header">
                    <div className="booking-img-wrap">
                      <div className="book-img">
                        <img
                          src="https://dev.alharamaincab.com/assets/img/cars/carImage.png"
                          alt="img"
                        />
                      </div>
                      <div className="book-info">
                        <h6>{confirmBookingData?.vehicle_detail?.name}</h6>
                        <p>
                          <i className="feather-map-pin" /> من{" "}
                          {confirmBookingData?.pickup_location?.name} {" إلى "}{" "}
                          {confirmBookingData?.drop_location?.name}
                        </p>
                      </div>
                    </div>
                    <div className="book-amount">
                      <p>المبلغ الإجمالي</p>
                      <h6>{confirmBookingData?.vehicle_detail.price}</h6>
                    </div>
                  </div>
                  <div className="booking-group">
                    <div className="booking-wrapper">
                      <div className="booking-title">
                        <h6>تفاصيل الحجز</h6>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>نوع الحجز</h6>
                            <p>حجز باقة</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>موقع الاستلام</h6>
                            <p>{confirmBookingData?.pickup_location?.name}</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>موقع التوصيل</h6>
                            <p>{confirmBookingData?.pickup_location?.name}</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>عدد الرحلات</h6>
                            <p>
                              {confirmBookingData?.vehicle_detail?.total_rides}
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>مقعد طفل</h6>
                            <p>
                              {confirmBookingData?.vehicle_detail?.baby_seat ===
                              true
                                ? "نعم"
                                : "لا"}
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>سعة الركاب</h6>
                            <p>
                              {
                                confirmBookingData?.vehicle_detail
                                  ?.passenger_capacity
                              }
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>سعة الأمتعة</h6>
                            <p>
                              {
                                confirmBookingData?.vehicle_detail
                                  ?.luggage_capacity
                              }
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>نوع الوقود</h6>
                            <p>
                              {confirmBookingData?.vehicle_detail?.fuel_type}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="booking-view">
                            <h6>تاريخ ووقت الاستلام</h6>
                            <p>{confirmBookingData?.pickup_date_time}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="booking-wrapper">
                      <div className="booking-title">
                        <h6>البيانات الشخصية</h6>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="input-block">
                            <label>الاسم</label>
                            <div className="group-img">
                              <Controller
                                name="name"
                                control={handleController}
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="أدخل الاسم"
                                      {...field}
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {personalDetailsErrors.name && (
                              <p className="text-danger pt-1">
                                {personalDetailsErrors.name.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="input-block">
                            <label>البريد الإلكتروني</label>
                            <div className="group-img">
                              <Controller
                                name="email"
                                control={handleController}
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="email"
                                      className="form-control"
                                      placeholder="أدخل البريد الإلكتروني"
                                      {...field}
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {personalDetailsErrors.email && (
                              <p className="text-danger pt-1">
                                {personalDetailsErrors.email.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="column-group-main">
                            <div className="input-block">
                              <label>تاريخ ووقت الاستلام</label>
                            </div>
                            <div className="input-block-wrapp">
                              <div className="input-block date-widget">
                                <div className="group-img">
                                  <Controller
                                    name="pickup_date_time1"
                                    control={handleController}
                                    render={({ field }) => (
                                      <ReactDatePicker
                                        selected={
                                          field.value
                                            ? new Date(field.value)
                                            : null
                                        }
                                        onChange={(date) =>
                                          field.onChange(date)
                                        }
                                        showTimeSelect
                                        dateFormat="yyyy-MM-dd HH:mm"
                                        placeholderText="اختر التاريخ والوقت"
                                        className="form-control"
                                        timeInputLabel="الوقت:"
                                      />
                                    )}
                                  />
                                  {personalDetailsErrors.pickup_date_time1 && (
                                    <p className="text-danger pt-1">
                                      {
                                        personalDetailsErrors.pickup_date_time1
                                          .message
                                      }
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="search-box-banner p-0 m-0">
                            <div className="input-block column-group-main max-width-100">
                              <label>رقم الهاتف</label>
                              <div className="phone-input-style PhoneInput">
                                <Controller
                                  name="phone_no"
                                  control={handleController}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <PhoneNumberField
                                      onChange={field.onChange}
                                    />
                                  )}
                                />
                              </div>
                              {personalDetailsErrors.phone_no && (
                                <p className="text-danger pt-1">
                                  {personalDetailsErrors.phone_no.message}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-btn modal-btn-sm text-end">
                    <button
                      onClick={closePackagesBooking}
                      disabled={isloading ? true : false}
                      className="btn btn-secondary"
                    >
                      إلغاء
                    </button>
                    <button
                      disabled={isloading ? true : false}
                      type="submit"
                      className="btn btn-primary"
                    >
                      {isloading ? "يرجى الانتظار" : "تأكيد"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {bookingConfirmToggle && <div className="modal-backdrop fade show"></div>}
      <section className="section popular-services popular-explore pt-10">
        <div className="container">
          <div className="tab-content">
            <div className="tab-pane active">
              <div className="row">
                {packagesList.length > 0 ? (
                  <>
                    {packagesList.length > 0 &&
                      packagesList
                        .slice(0, 60)
                        .map((item: any, index: number) => (
                          <>
                            <div
                              className="col-lg-4 col-md-6 col-12 text-center"
                              data-aos="fade-down"
                              key={index}
                            >
                              <div className="listing-item">
                                <div className="listing-img">
                                  <Link
                                    to={getPackageUrl(item)}
                                  >
                                    <ImageWithBasePath
                                      src={item?.image}
                                      className="img-fluid"
                                      alt="Toyota"
                                    />
                                  </Link>
                                  <div
                                    className="fav-item"
                                  >
                                    <span className="featured-text">
                                      {item?.vehicle_detail.vehicle_type?.name}
                                    </span>
                                    <Link
                                      to={getPackageUrl(item)}
                                      className={`fav-icon ${
                                       ""
                                      }`}
                                    >
                                      <i className="feather icon-heart" />
                                    </Link>
                                  </div>
                                </div>
                                <div className="listing-content">
                                  <div className="listing-features">
                                    <Link
                                      to={getPackageUrl(item)}
                                      className="author-img"
                                    >
                                      <ImageWithBasePath
                                        src={
                                          item?.vehicle_detail?.vehicle_type
                                            ?.icon
                                        }
                                        alt="author"
                                      />
                                    </Link>
                                    <h3 className="listing-title">
                                      <Link to={getPackageUrl(item)}>
                                        {item?.name}
                                      </Link>
                                    </h3>
                                    <div className="list-rating">
                                      <span className="featured-text">
                                        {item?.vehicle_detail?.name}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="listing-details-group">
                                    <ul>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.vehicle_type
                                                ?.connectivity_icon
                                            }
                                            alt="Auto"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail?.vehicle_type?.connectivity
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail
                                                .luggage_capacity_icon
                                            }
                                            alt="10 KM"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail
                                              ?.luggage_capacity
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.disabled_icon
                                            }
                                            alt="diabled"
                                          />
                                        </span>
                                        <p>{item?.vehicle_detail?.disabled===1?"نعم":"لا"}</p>
                                      </li>
                                    </ul>
                                    <ul>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.vehicle_type
                                                ?.comfort_icon
                                            }
                                            alt="confort"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail?.vehicle_type?.comfort
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail?.vehicle_type
                                                ?.safety_icon
                                            }
                                            alt=""
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail?.vehicle_type?.safety
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>
                                          <ImageWithBasePath
                                            src={
                                              item?.vehicle_detail
                                                .passenger_capacity_icon
                                            }
                                            alt="Persons"
                                          />
                                        </span>
                                        <p>
                                          {
                                            item?.vehicle_detail
                                              ?.passenger_capacity
                                          }
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="listing-location-details justify-content-center">
                                    <div className="listing-price text-center">
                                      <h6>{item?.price} ريال</h6>
                                    </div>
                                  </div>
                                  <div className="listing-button">
                                    <button
                                      onClick={() =>
                                        handleBookingPackages(item)
                                      }
                                      className="btn btn-order"
                                    >
                                      {isloading ? "يرجى الانتظار" : "احجز الآن"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                  </>
                ) : (
                  <>
                    <div className="col-lg-4 col-md-6 col-12 text-center">
                      <ProductCardLoader />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 text-center">
                      <ProductCardLoader />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 text-center">
                      <ProductCardLoader />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12" data-aos="fade-down">
              <div className="about-content">
                <h2>تاكسي مطار جدة الموثوق لنقل العمرة</h2>
                <p>
                  مطار الملك عبدالعزيز الدولي هو نقطة الوصول الرئيسية لملايين معتمري العمرة كل عام. بعد رحلة
                  طويلة، وإجراءات الجوازات، واستلام الحقائب، آخر ما يحتاجه المسافرون هو عدم اليقين بشأن وسيلة
                  النقل. تجعل الحرمين كاب حجز تاكسي مطار جدة أمراً سهلاً: رتب نقلك مسبقاً، واستلم تفاصيل تنسيق
                  واضحة، وسافر مباشرة من مطار جدة إلى فندقك في مكة أو المدينة أو مدينة جدة.
                </p>
                <p>
                  تدعم خدمة تاكسي مطار جدة لدينا المسافرين الفرديين، والأزواج، والعائلات، والمجموعات الكبيرة.
                  تشمل خيارات السيارات سيدان عادية، ودفع رباعي واسع للعائلات بحقائب متعددة، وهايس للمجموعات
                  التي تحتاج سعة أمتعة إضافية. تتوفر أيضاً رحلات العودة للمطار، مما يسهل إدارة نقل الوصول
                  والمغادرة مع نفس مزود الخدمة الموثوق.
                </p>
                <p>
                  يمكن أن تعطل تأخيرات الطيران، والوصول في وقت متأخر من الليل، ومواسم العمرة المزدحمة النقل
                  غير المخطط له. مع الحرمين كاب، يتم تنسيق استقبالك من مطار جدة قبل الهبوط — عبر الهاتف أو
                  واتساب — حتى يكون سائقك جاهزاً عند خروجك من المبنى. احجز مبكراً لتأمين السيارة المفضلة لديك
                  وابدأ رحلة حجك أو عمرتك بثقة.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ArJaddahAirportTaxiService;
